<template>
  <v-row dense>
    <v-col cols="12" sm="12" md="12">
      <v-banner
        color="blue-grey lighten-5"
        class="black--text"
        shaped
        single-line
      >
        Identificación médica
      </v-banner>
    </v-col>
    <v-col cols="12" sm="12" md="12">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-row>
          <v-col cols="4">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Aseguradora"
              rules="required"
            >
              <v-autocomplete
                :items="healthInsurances"
                label="Aseguradora*"
                clearable
                required
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
                v-model.trim="medicalIdentityData.healthInsurance"
                no-data-text="Sin resultados disponibles."
                item-text="name"
                return-object
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-autocomplete>
            </validation-provider>
          </v-col>
          <v-col v-if="viewNewHealthInsurance()" cols="4">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Nombre de aseguradora"
              rules="max:100|required"
            >
              <v-text-field
                required
                :counter="100"
                maxlength="100"
                v-model.trim="medicalIdentityData.nameHealthInsurance"
                label="Nombre de aseguradora*"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon slot="append" :color="valid ? 'success' : ''">
                  {{ valid ? " mdi-check" : "" }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col v-if="viewPatientNumber()" cols="4">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Número de afiliación"
              rules="max:50"
            >
              <v-text-field
                :counter="50"
                maxlength="50"
                v-model.trim="medicalIdentityData.membershipNumber"
                label="Número de afiliación (opcional)"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="
                    valid && medicalIdentityData.membershipNumber
                      ? 'success'
                      : ''
                  "
                >
                  {{
                    valid && medicalIdentityData.membershipNumber
                      ? " mdi-check"
                      : ""
                  }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col v-if="viewDataIMSS()" cols="4">
            <validation-provider
              v-slot="{ errors, valid }"
              name="NSS"
              rules="max:11"
            >
              <v-text-field
                :counter="11"
                maxlength="11"
                v-model.trim="medicalIdentityData.imssNumber"
                label="NSS (opcional)"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="
                    valid && medicalIdentityData.imssNumber ? 'success' : ''
                  "
                >
                  {{
                    valid && medicalIdentityData.imssNumber ? " mdi-check" : ""
                  }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
          <v-col v-if="viewDataIMSS()" cols="4">
            <validation-provider
              v-slot="{ errors, valid }"
              name="Agregar médico"
              rules="max:8"
            >
              <v-text-field
                :counter="8"
                maxlength="8"
                v-model.trim="medicalIdentityData.medicalAggregated"
                label="Agregar médico (opcional)"
                clearable
                autocomplete="off"
                :error-messages="errors"
                dense
                clear-icon="mdi-eraser"
              >
                <v-icon
                  slot="append"
                  :color="
                    valid && medicalIdentityData.medicalAggregated
                      ? 'success'
                      : ''
                  "
                >
                  {{
                    valid && medicalIdentityData.medicalAggregated
                      ? " mdi-check"
                      : ""
                  }}
                </v-icon>
              </v-text-field>
            </validation-provider>
          </v-col>
        </v-row>
        <br />
        <br />
        <v-row>
          <v-col cols="12" sm="12" md="12" align="center">
            <v-menu
              offset-x
              bottom
              rigth
              :close-on-content-click="true"
              rounded="lg"
            >
              <template v-slot:activator="{ on: menu, attrs }">
                <v-btn
                  type="button"
                  class="mb-4"
                  :disabled="invalid"
                  v-bind="attrs"
                  depressed
                  outlined
                  v-on="{ ...menu }"
                  color="primary"
                  @click="nextstep()"
                >
                  Siguiente paso
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </v-col>
        </v-row>
      </validation-observer>
    </v-col>
  </v-row>
</template>

<script>
import { HealthInsuranceRequest } from "@/core/request/";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  props: {
    medicalIdentityData: Object,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      healthInsurances: [],
    };
  },
  created() {
    this.listInsurances();
  },
  methods: {
    listInsurances() {
      HealthInsuranceRequest.listAllHealthInsurance().then((res) => {
        this.healthInsurances = res.data.data;
      });
    },
    viewPatientNumber() {
      if (
        this.medicalIdentityData?.healthInsurance?.name === "NO APLICA" ||
        this.medicalIdentityData?.healthInsurance?.name === "IMSS"
      ) {
        this.medicalIdentityData.membershipNumber = null;
        this.medicalIdentityData.nameHealthInsurance = null;
        return false;
      }
      return true;
    },
    viewNewHealthInsurance() {
      if (this.medicalIdentityData?.healthInsurance?.name === "OTRO") {
        this.medicalIdentityData.nameHealthInsurance = null;
        return true;
      }
      return false;
    },
    viewDataIMSS() {
      if (this.medicalIdentityData?.healthInsurance?.name === "IMSS") {
        return true;
      }
      this.medicalIdentityData.imssNumber = null;
      this.medicalIdentityData.medicalAggregated = null;
      return false;
    },
    nextstep() {
      this.$emit("nextstep", 2);
    },
  },
};
</script>
